import { useTranslation } from "react-i18next";

const EventRow = ({ event }) => {
  const { t, i18n } = useTranslation();

  const displayableDate = new Date(event.beginDate)
    .toLocaleString()
    .split(",")[0];

  const disciplines =
    i18n.language === "it-it" ? event.disciplinesIt : event.disciplinesEn;

  const displayableDisciplines = disciplines
    .map((a) => <span>{a}</span>)
    .reduce((a, b) => (
      <>
        {a} • {b}
      </>
    ));

  return (
    <tr>
      <td className="event-data" align="left">
        <div className="mj-column-per-80 mj-column">
          <table
            cellPadding="0"
            cellSpacing="0"
            border="0"
            width="100%"
            valign="middle"
          >
            <tbody>
              <tr>
                <td className="logo">
                  <a href={event.link}>
                    <img src={event.logoLink} alt="ENDU" />
                  </a>
                </td>
                <td>
                  <h3>{event.name}</h3>
                  <p className="disciplines">{displayableDisciplines}</p>
                  <p>
                    {displayableDate} • {event.city} ({event.province})
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mj-column-per-20 mj-column">
          <table
            cellPadding="0"
            cellSpacing="0"
            border="0"
            width="100%"
            valign="middle"
            align="right"
          >
            <tbody>
              <tr valign="middle">
                <td align="right" valign="middle">
                  <a href={event.link} className="btn btn-primary">
                    {t("subscribe")}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </td>
    </tr>
  );
};

export default EventRow;
